import { render, staticRenderFns } from "./manage-user-claims-modal.vue?vue&type=template&id=99c1dbd0&"
import script from "./manage-user-claims-modal.vue?vue&type=script&lang=js&"
export * from "./manage-user-claims-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports